<template>
  <table class="striped admin-templates-table">
    <caption v-html="caption" v-if="caption" />
    <colgroup>
      <col width="34%" />
      <col width="33%" />
      <col width="33%" />
    </colgroup>
    <thead>
      <tr>
        <th>Template Name</th>
        <th>Template Type</th>
        <th>Attachment</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="template in paginatedTemplates"
        :key="template.id"
        :class="selectedId === template.id ? 'selectedIds' : 'selectable'"
        @click="handleSelect(template)"
      >
        <td>{{ template.name }}</td>
        <td>{{ template.type.name }}</td>
        <td>{{ template.filename }}</td>
      </tr>
      <tr v-if="templates.length === 0">
        <td class="no-records" colspan="3">
          There are currently no templates in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls" colspan="3">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("templates")],

  props: {
    caption: {
      type: String,
      default: undefined,
    },
    selectedId: {
      type: [Number, String],
      default: -1,
    },
    templates: {
      type: Array,
    },
  },

  methods: {
    handleSelect(template) {
      this.$emit("select", template);
    },
  },
};
</script>